module.exports = __webpack_public_path__ + "static/media/Capgemini-Logo.e059a019.png";